import Axios from "../helpers/axios";

export const getAllUsersNotifications = () => {
  return Axios.get("/users-notifications");
};

export const updateUsersNotificationIsReadStatus = () => {
  return Axios.put("/users-notifications/update/is_read/status");
};
